export default __webpack_public_path__ + "static/media/photo5.144b43df.jpg";